<svg
    height="10"
    viewBox="0 0 17 10"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-chevron"
    focusable="false"
    aria-hidden="true"
    [ngClass]="directionClass()"
>
    <path
        d="m782.5 91.2573593h-10v-10"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        transform="matrix(.70710678 -.70710678 .70710678 .70710678 -602.268686 490.039718)"
    />
</svg>